export enum ActionType {
    ADD = "ADD",
    DELETE = "DELETE",
    SEND = "SEND",
    SEND_AND_DELETE = "SEND_AND_DELETE",
    TRIGGER = "TRIGGER",
}
